import ColorizedIndicatorStateProvider from "../components/settings/ColorSettings/ColorizedIndicators/ColorizedIndicatorStateProvider";
import ServiceTypeColorStateProvider from "../components/settings/ColorSettings/ServiceTypeColor/ServiceTypeColorStateProvider";
import SettingsView from "./SettingsView";

const SettingsViewContainer = () => {
  return (
    <ColorizedIndicatorStateProvider>
      <ServiceTypeColorStateProvider>
        <SettingsView />
      </ServiceTypeColorStateProvider>
    </ColorizedIndicatorStateProvider>
  );
};

export default SettingsViewContainer;
